import { render, staticRenderFns } from "./ChitChat.vue?vue&type=template&id=5a00c695&scoped=true&"
import script from "./ChitChat.vue?vue&type=script&lang=ts&"
export * from "./ChitChat.vue?vue&type=script&lang=ts&"
import style0 from "./ChitChat.vue?vue&type=style&index=0&id=5a00c695&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a00c695",
  null
  
)

export default component.exports